module.exports = __webpack_public_path__ + "img/home4.c291cb8a.svg";